document.addEventListener('DOMContentLoaded', function () {
  console.log('custom js loaded');

  function executeSearch(searchInput) {
    const searchTerm = searchInput.value.trim();
    if (searchTerm.length > 0) {
      const searchForm = searchInput.closest('form');
      if (searchForm) {
        searchForm.submit();
      } else {
        const searchUrl = `/search?q=${encodeURIComponent(searchTerm)}`;
        window.location.href = searchUrl;
      }
    }
  }

  const desktopSearchInput = document.querySelector('.header__search-input');
  const desktopSearchContent = document.querySelector('.header__sidebar .search__content');
  const desktopMagnifier = document.querySelector('.header__btn-search i[onclick]');

  if (desktopSearchInput && desktopSearchContent) {
    const closeBtn = document.createElement('button');
    closeBtn.className = 'search__close-btn';
    closeBtn.setAttribute('aria-label', 'Close search');
    closeBtn.setAttribute('type', 'button');
    desktopSearchContent.insertBefore(closeBtn, desktopSearchContent.firstChild);

    function showSearchContent() {
      desktopSearchContent.classList.add('is-visible');
      document.documentElement.classList.add('search-active');
    }

    function hideSearchContent() {
      desktopSearchContent.classList.remove('is-visible');
      document.documentElement.classList.remove('search-active');
    }

    if (desktopMagnifier) {
      desktopMagnifier.removeAttribute('onclick');
      desktopMagnifier.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        executeSearch(desktopSearchInput);
      });
    }

    desktopSearchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        executeSearch(desktopSearchInput);
      }
    });

    desktopSearchInput.addEventListener('input', function () {
      if (this.value.length > 0) {
        showSearchContent();
      }
    });

    desktopSearchInput.addEventListener('focus', function () {
      if (this.value.length > 0) {
        showSearchContent();
      } else {
        hideSearchContent();
      }
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideSearchContent();
      desktopSearchInput.value = '';
    });
  }

  const mobileSearchInput = document.querySelector('.mobile-search-wrap input');
  const mobileSearchContent = document.querySelector('.search__content-mobile');
  const mobileMagnifier = document.querySelector('.mobile-search-wrap i, .mobile-search-wrap button'); // Adjust selector as needed

  if (mobileSearchInput && mobileSearchContent) {
    const closeBtn = document.createElement('button');
    closeBtn.className = 'search__close-btn';
    closeBtn.setAttribute('aria-label', 'Close search');
    closeBtn.setAttribute('type', 'button');
    mobileSearchContent.insertBefore(closeBtn, mobileSearchContent.firstChild);

    function showMobileSearchContent() {
      mobileSearchContent.classList.add('is-visible');
      document.documentElement.classList.add('search-active');
    }

    function hideMobileSearchContent() {
      mobileSearchContent.classList.remove('is-visible');
      document.documentElement.classList.remove('search-active');
    }

    if (mobileMagnifier) {
      mobileMagnifier.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        executeSearch(mobileSearchInput);
      });
    }

    mobileSearchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        executeSearch(mobileSearchInput);
      }
    });

    mobileSearchInput.addEventListener('input', function () {
      if (this.value.length > 0) {
        showMobileSearchContent();
      }
    });

    mobileSearchInput.addEventListener('focus', function () {
      if (this.value.length > 0) {
        showMobileSearchContent();
      } else {
        hideMobileSearchContent();
      }
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      hideMobileSearchContent();
      mobileSearchInput.value = '';
    });
  }

  document.addEventListener('click', function (e) {
    const desktopSearchWrapper = document.querySelector('.header__btn-search');
    const mobileSearchWrapper = document.querySelector('.mobile-search-wrap');

    if (desktopSearchWrapper && !desktopSearchWrapper.contains(e.target)) {
      const desktopContent = document.querySelector('.header__sidebar .search__content');
      if (desktopContent && desktopContent.classList.contains('is-visible')) {
        desktopContent.classList.remove('is-visible');
        document.documentElement.classList.remove('search-active');
      }
    }

    if (mobileSearchWrapper && !mobileSearchWrapper.contains(e.target)) {
      const mobileContent = document.querySelector('.search__content-mobile');
      if (mobileContent && mobileContent.classList.contains('is-visible')) {
        mobileContent.classList.remove('is-visible');
        document.documentElement.classList.remove('search-active');
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {

  function adjustSearchContentPosition() {

    const header = document.getElementById('header');
    const searchContent = document.querySelector('.search__content-mobile');
    const searchContent_desktop = document.querySelector('.search__content-desktop');

    if (header && searchContent) {
      const headerHeight = header.offsetHeight;
      const newTopPosition = headerHeight;

      searchContent.style.top = newTopPosition + 'px';
      searchContent.style.height = `calc(100% - ${newTopPosition}px)`;
      searchContent_desktop.style.height = `calc(100% - ${newTopPosition}px)`
      searchContent_desktop.style.top = newTopPosition + 'px';
    }
  }

  adjustSearchContentPosition();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      adjustSearchContentPosition();
    }, 250);
  });

  const headerElement = document.getElementById('header');
  if (headerElement) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          setTimeout(adjustSearchContentPosition, 50);
        }
      });
    });

    observer.observe(headerElement, { attributes: true });
  }
});